<template>
    <div class="footer">
        <div class="wrap clearfix">
            <a href="#" class="logo" @click="toUrl('/')"><img src="@/assets/images/common/brand/logo.png" alt=""></a>
            <div class="rts clearfix">
                <div class="nav clearfix">
                    <ul>
                        <li @click="toUrl('/')"><a>Home</a></li>
                        <li @click="toUrl('/product')"><a>Product</a></li>
                        <li @click="toUrl('/dashboard')"><a>Dashboard</a></li>
                        <li @click="toUrl('/support')"><a>Support</a></li>
                    </ul>
                    <ul>
                        <li @click="toDeail('policy',3)"><a>Terms of Use</a></li>
                        <li @click="toDeail('policy',2)"><a>Refund Policy</a></li>
                        <li @click="toDeail('policy',1)"><a>Privacy Policy</a></li>
                    </ul>
                </div>
                <div class="ne">
                    <ul>
                        <li @click="toOpen(socialUrl.twitter)"><a><img src="@/assets/images/common/footer/icon-1.png" alt=""></a></li>
                        <li @click="toOpen(socialUrl.discord)"><a><img src="@/assets/images/common/footer/icon-2.png" alt=""></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            socialUrl: {},
        }
    },
    mounted() {
        this.socialUrl = this.$store.state.socialUrl || {}
    },
    methods: {
        toUrl(url) {
            this.$router.push({path: url})
        }, toDeail(name, id) {
            const {href} = this.$router.resolve({name: name, query: {id: id}})
            window.open(href, '_blank')
        },
        toOpen(url) {
            if (url) window.open(url, '_blank')
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
